export default class AcousticSignalManager {

    sdkReady = false;
    signalQueue = [];

    constructor(eventManager) {
        this.eventManager = eventManager;
        this.init();
    }

    init() {
        if (!window.TLT) {
            return;
        }
        window.TLT.initPremium({
            appKey: "9700b817d4874957b3b998e33a345ef7",
            postUrl: "https://lib-eu-1.brilliantcollector.com/collector/collectorPost",
            callback: this.initLogSignal
        });
    }

    initLogSignal = () => {
        this.sdkReady = true;
        while (this.signalQueue.length > 0) {
            window.TLT.logSignal(this.signalQueue.shift());
        }
    }

    registerSubscribers = ()=>  {
        this.eventManager.subscribe("app.start", this.pageView);
        this.eventManager.subscribe("faq.click", this.faqClick);
        this.eventManager.subscribe("price.solo", this.soloPrice);
        this.eventManager.subscribe("price.perPerson", this.perPersonPrice);
        this.eventManager.subscribe("wishlist.add", this.wishListAdd);
        this.eventManager.subscribe("wishlist.remove", this.wishListRemove);
        this.eventManager.subscribe("cruise.view", this.cruiseView);
        this.eventManager.subscribe("cruise.search", this.siteSearchView);
        this.eventManager.subscribe("form.submit", this.formSubmission);
        this.eventManager.subscribe("preferences.update", this.preferencesUpdate);
    }

    pageView = (event) => {
        let signal = {
            signalType: 'pageView',
            category: 'Behaviour',
            name: 'pageView from website',
            effect: 'positive',
            ...event.detail,
        }
        this.sendSignal(signal);
    }

    cruiseView = (event) => {
        let signal = {
            signalType: "productView",
            category: "Behavior",
            name: "productView generated by website",
            effect: "positive",
            ...JSON.parse(event.detail),
            currency: 'GBP',
        };
        this.sendSignal(signal);
    }

    faqClick = (event) => {
        let signal = {
            signalType: "productConfiguration",
            category: "Behavior",
            name: "FAQ interction from website",
            effect: "positive",
            ...event.detail,
        }
        this.sendSignal(signal);
    }

    perPersonPrice = (event) => {
        let signal = {
            signalType: "productConfiguration",
            category: "Behavior",
            name: "perPersonPrice from website",
            effect: "positive",
            ...event.detail,
        }

        this.sendSignal(signal);
    }

    soloPrice = (event) => {
        let signal = {
            signalType: "productConfiguration",
            category: "Behavior",
            name: "soloPrice from website",
            effect: "positive",
            ...event.detail,
        }
        this.sendSignal(signal);
    }

    wishListAdd = (event) => {
    }

    wishListRemove = (event) => {
    }

    siteSearchView = (event) => {
        let signal = {
            signalType: "onSiteSearch",
            category: "Behavior",
            name: "onSiteSearch from website",
            effect: "positive",
            ...event.detail,
        }
        this.sendSignal(signal);
    }

    accountView = (event) => {
        let signal = {
            signalType: "accountView",
            category: "Behavior",
            name: "accountView from website",
            effect: "positive",
            ...event.detail,
        }
        this.sendSignal(signal);
    }

    formSubmission = (event) => {
        this.sendSignal(event.detail);
    }

    preferencesUpdate = (event) => {
        this.sendSignal(event.detail)
    }

    getAudience = () => {
        return fetch('/session/user', {
            method: 'GET',
            credentials: 'same-origin',
            headers: {
                Accept: 'application/json'
            }
        })
            .then(response => response.json())
            .then(data => ({
                audience: {
                    ClientUID: data.trackingId,
                    Email: data.user ? data.user.email : null
                }
            }))
            .catch(error => {
                console.error(error);
                return {
                    audience: {
                        ClientUID: null,
                        Email: null
                    }
                };
            });
    };


    sendSignal = (signal) => {
        return this.getAudience().then(audience => {
            signal = {
                ...signal,
                ...audience
            };

            if (!this.sdkReady) {
                this.signalQueue.push(signal);
                return;
            }

            window.TLT.logSignal(signal);
        });
    };
}